import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'; 
import { 
  collection,
  getDocs,
  query,  
  Timestamp, 
} from 'firebase/firestore';
import { EventDate  } from 'src/@types/event';
import { EventCategory  } from 'src/@types/events_org'; 
import { DB  } from 'src/contexts/FirebaseContext'; 

// Define a service using a base URL and expected endpoints
export const EventCategoriesApi = createApi({
  reducerPath: 'EventCategoriesApi',
  baseQuery: fakeBaseQuery(),
  refetchOnReconnect: true,
  tagTypes: [
    'Eventcategories',
  ],
  endpoints: (builder) => ({
    // event  category
       fetchEventCategory: builder.query<EventCategory[], string>({
      async queryFn() { 
        let categorisRef = collection(DB, 'eventcategories');
        const qCategory = query(categorisRef );
        let categoryData: EventCategory[] = (await getDocs(qCategory)).docs.map(
          (doc: any) => ({
            id: doc.id,
            createdAt: doc.data()?.createdAt
              ? ((doc.data()?.createdAt as Timestamp).toDate() as EventDate)
              : undefined,
            ...doc.data(),
          })
        );
        return { data: categoryData };
      },
      providesTags: (result, error, authId) =>
        result
          ? [
              // eslint-disable-next-line no-empty-pattern
              ...result.map(({   }) => ({ type: 'Eventcategories' as const,  })),
              { type: 'Eventcategories', id: 'LIST' },
            ]
          : [{ type: 'Eventcategories', id: 'LIST' }],
    }), 
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {  
  useFetchEventCategoryQuery,
} = EventCategoriesApi;
